import { Home as HomePage } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: HomePage,
  beforeLoad: () => {
    document.title = "Maifud: El mercado de lo imperfecto";
  },
});
